import useFullyFledgedField from '@gef-ui/form-core/hooks/field/useFullyFledgedField';
import chainHandlers from "@gef-ui/utils/chainHandlers";
import MuiTextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import defaultToEmptyString from "ramda-extension/es/defaultToEmptyString";
import React from 'react';
import { validationDisplayTypes } from '../constants';
import { createBaseInputProps, resolveHiddenProp, resolveInputLabelProps, resolveValidationColor, resolveVariant, useFieldDefaultValue, useHelperText } from '../utils';
export const COMPONENT_NAME = 'TextField';
const TextField = (inProps)=>{
    const props = useFieldDefaultValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { fieldName, fieldIndices, initiallyDirty, viewParser, modelParser, onBlur, onFocus, onChange, disabled: disabledByProp, defaultValue, validationDisplay = validationDisplayTypes.PLAIN_TEXT, slotProps = {}, helperText, tooltip, variant, ...other } = props;
    const { value, errorMessage, handleBlur, handleChange, setFocusFalse, setFocusTrue, fieldId, validationType, disabled, localizedLabel, asyncValidationInProgress, hidden } = useFullyFledgedField({
        fieldName,
        fieldIndices,
        initiallyDirty,
        modelParser,
        viewParser,
        defaultValue,
        disabled: disabledByProp
    });
    const validationColor = resolveValidationColor(validationType, validationDisplay);
    const errorOrHelperText = useHelperText(validationDisplay, errorMessage, helperText);
    const { input = {}, inputLabel = {}, formHelperText = {}, ...otherSlotProps } = slotProps;
    return /*#__PURE__*/ React.createElement(MuiTextField, {
        id: fieldId,
        disabled: disabled,
        helperText: errorOrHelperText,
        color: validationColor,
        value: defaultToEmptyString(value),
        label: localizedLabel,
        onChange: chainHandlers([
            handleChange,
            onChange
        ]),
        onBlur: chainHandlers([
            setFocusFalse,
            handleBlur,
            onBlur
        ]),
        onFocus: chainHandlers([
            setFocusTrue,
            onFocus
        ]),
        slotProps: {
            input: createBaseInputProps({
                tooltipValidation: validationDisplay === validationDisplayTypes.TOOLTIP,
                validationColor,
                asyncValidationInProgress,
                errorMessage,
                tooltip,
                InputProps: input,
                variant
            }),
            inputLabel: {
                ...resolveInputLabelProps(variant, validationColor, other),
                ...inputLabel
            },
            formHelperText: {
                validation: validationColor,
                ...formHelperText
            },
            ...otherSlotProps
        },
        ...resolveVariant(variant),
        ...other,
        ...resolveHiddenProp(hidden, other)
    });
};
TextField.propTypes = {
    InputProps: PropTypes.object,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    fieldIndices: PropTypes.arrayOf(PropTypes.number),
    fieldName: PropTypes.string,
    helperText: PropTypes.node,
    initiallyDirty: PropTypes.bool,
    modelParser: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    slotProps: PropTypes.shape({
        input: PropTypes.object,
        inputLabel: PropTypes.object,
        formHelperText: PropTypes.object,
        htmlInput: PropTypes.object,
        select: PropTypes.object
    }),
    tooltip: PropTypes.string,
    validationDisplay: PropTypes.oneOf(Object.keys(validationDisplayTypes)),
    variant: PropTypes.string,
    viewParser: PropTypes.func
};
export default TextField;
